module.exports = __webpack_public_path__ + "static/media/roly.8e863842.jpg";